// src/pages/AIControlRoomAdaptive/hooks/useCampaigns.js

import { useState, useEffect } from 'react';
import supabase from '../../../lib/supabaseClient';

export function useCampaigns(tenantId) {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Don't fetch if no tenant or "all" selected
    if (!tenantId || tenantId === 'all') {
      setData([]);
      return;
    }

    const fetchCampaigns = async () => {
      setIsLoading(true);
      try {
        const { data: campaigns, error: fetchError } = await supabase
          .from('campaigns')
          .select('id, name')
          .eq('tenant_id', tenantId)
          .order('name');

        if (fetchError) throw fetchError;

        setData(campaigns || []);
        setError(null);
      } catch (err) {
        console.error('[useCampaigns] Error:', err.message);
        setError(err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchCampaigns();
  }, [tenantId]);

  return { data, isLoading, error };
}

export default useCampaigns;